import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { AdminPageHeader, Form, AdminFormAction } from '@ui';
import { TXUsersForm } from '@lp/features/admin/forms/TXUsersForm/TXUsersForm';
import { CREATE_TX_USER_FORM_DEFAULT_VALUES, createTxUserSchema } from '@lp/features/admin/forms/TXUserFormBase';
import { useContext } from 'react';
import { AuthContext } from '@lp/core/auth';
import { useCreateCustomerMutation } from '@/queries/customer';
import { useUploadFile } from '@/hooks/useUploadFile';
import { retrieveUnifiedError } from '@/api/utils';
import { CreateTXUserFormValues } from '@/types/customer';
import { AdminPermissions } from '@/permissions';
import { FileType } from '@/queries/file';

export const TXUsersCreate = () => {
  const navigate = useNavigate();
  const { mutateAsync } = useCreateCustomerMutation();
  const { uploadFiles } = useUploadFile(FileType.Customer);
  const { checkPermission } = useContext(AuthContext);

  const hasCreatePermissions = checkPermission(AdminPermissions.TxCenterCreate);

  const handleBackToList = () => {
    navigate('/admin/customers/tx_users');
  };

  const handleSubmit = async (data: CreateTXUserFormValues) => {
    try {
      let uploadedFile;
      if (data.photo) {
        uploadedFile = await uploadFiles([data.photo]);
      }

      const rolesAndPermissions = [...data.roles, ...data.permissions];

      await mutateAsync({
        firstName: data.firstName,
        lastName: data.lastName,
        email: data.email,
        primaryPhone: data.primaryPhone,
        secondaryPhone: data.secondaryPhone === '' ? undefined : data.secondaryPhone,
        roles: rolesAndPermissions,
        photoPath: uploadedFile ? uploadedFile[0].fileName : undefined,
        txCenterId: data.txCenterId,
      });

      toast.success(`TX User created successfully.`);
      handleBackToList();
    } catch (e) {
      const error = retrieveUnifiedError(e);
      toast.error(error.message);
    }
  };

  return (
    <Form<CreateTXUserFormValues>
      defaultValues={CREATE_TX_USER_FORM_DEFAULT_VALUES}
      schema={createTxUserSchema}
      onSubmit={handleSubmit}
    >
      <div className="flex flex-col gap-9">
        <AdminPageHeader title="Create TX User" backToListLink="/admin/customers/tx_users">
          <AdminFormAction type="create" handleClick={handleBackToList} hasCreatePermissions={hasCreatePermissions} />
        </AdminPageHeader>
        <TXUsersForm isEditMode={false} isReadOnly={!hasCreatePermissions} />
      </div>
    </Form>
  );
};
